'use client';

import { useEffect, useState } from 'react';
import { useNavigateLogin } from '@/app/_utils/session/use-navigate-login';
import { Button } from '../button';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
import { Modal } from '../modal';
import { CustomEventType } from '../types';
const AppAuthModal = () => {
  const {
    isMobile
  } = useMobileDetect();
  const navigateLogin = useNavigateLogin();
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = () => {
    setIsOpen(false);
  };
  useEffect(() => {
    document.addEventListener(CustomEventType.AuthModal, () => {
      setIsOpen(true);
    });
    return () => {
      document.addEventListener(CustomEventType.AuthModal, () => {
        setIsOpen(false);
      });
    };
  }, []);
  return <Modal handleClose={handleClose} isOpen={isOpen} title='ورود به حساب کاربری' width='w-full lg:w-[508px]' className='bottom-0 h-fit' data-sentry-element="Modal" data-sentry-component="AppAuthModal" data-sentry-source-file="app-auth-modal.tsx">
            <div className='flex flex-col gap-11 lg:gap-6'>
                <p className='text-body-14 text-text-black lg:text-body-16'>
                    مشکلی پیش آمده است. لطفا دوباره وارد شوید.
                </p>

                <Button onClick={() => navigateLogin()} graphicStyle='filled' size={isMobile ? 'medium' : 'large'} className='mx-auto' data-sentry-element="Button" data-sentry-source-file="app-auth-modal.tsx">
                    ورود به حساب کاربری
                </Button>
            </div>
        </Modal>;
};
export default AppAuthModal;